import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";

import { Logout } from "./components/logout";
import { WebPage } from "./components/web-page";
import { Login } from "./pages/login";
import { ResetPassword } from "./pages/reset-password";
import { BoardMeetings } from "./pages/web/board-meetings";
import { Contracts } from "./pages/web/contracts";
import { Issues } from "./pages/web/issues";
import { Page } from "./pages/web/page";
import { Maintenance } from "./pages/web/maintenance";
import { Procurements } from "./pages/web/procurements";
import { Registers } from "./pages/web/registers";
import { Roles } from "./pages/web/roles";
import { Users } from "./pages/web/users";
import { SearchPageResult } from "./pages/web/search-page-result";
import { useAuthStore } from "./stores/auth";

export function WebApp() {
  return <Paths />;
}

function Paths() {
  const navigate = useNavigate();
  const { isAuth } = useAuthStore();

  useEffect(() => {
    let handleEsc: (event: KeyboardEvent) => void;
    if (!isAuth) {
      // Listen to esc key
      handleEsc = (event: KeyboardEvent) => {
        if (event.ctrlKey && event.key === "Escape") {
          // navigate to login page
          navigate("/login");
        }
      };
      window.addEventListener("keydown", handleEsc);
    }
    return () => {
      if (handleEsc) {
        window.removeEventListener("keydown", handleEsc);
      }
    };
  });

  return (
    <Routes>
      <Route
        element={
          <WebPage>
            <Page />
          </WebPage>
        }
        path="/:slug1?/:slug2?"
      />
      <Route
        element={
          <WebPage>
            <SearchPageResult />
          </WebPage>
        }
        path="/search"
      />
      <Route
        element={
          <WebPage>
            <Login resetPasswordPath="/reset-password" />
          </WebPage>
        }
        path="/login"
      />
      <Route
        element={
          <WebPage>
            <ResetPassword />
          </WebPage>
        }
        path="/reset-password"
      />
      <Route element={<Logout />} path="/logout" />
      <Route
        element={
          <WebPage>
            <Registers />
          </WebPage>
        }
        path="/admin/register/*"
      />
      <Route
        element={
          <WebPage>
            <Contracts />
          </WebPage>
        }
        path="/admin/contract/*"
      />
      <Route
        element={
          <WebPage>
            <Issues />
          </WebPage>
        }
        path="/admin/issue/*"
      />
      <Route
        element={
          <WebPage>
            <Procurements />
          </WebPage>
        }
        path="/admin/procurement/*"
      />
      <Route
        element={
          <WebPage>
            <BoardMeetings />
          </WebPage>
        }
        path="/admin/board-meeting/*"
      />
      <Route
        element={
          <WebPage>
            <Maintenance />
          </WebPage>
        }
        path="/admin/maintenance/*"
      />
      <Route
        element={
          <WebPage>
            <Roles />
          </WebPage>
        }
        path="/admin/role/*"
      />
      <Route
        element={
          <WebPage>
            <Users />
          </WebPage>
        }
        path="/admin/user/*"
      />
    </Routes>
  );
}
